import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import PopupWrapper from "../components/PopupWrapper";
import ApplianceListDisc from "../components/ApplianceListDisc";
import { accountHomeViewActions } from "../_actions";
import Spacer from "../components/Spacer";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import { withCookies } from "react-cookie";
import AccountSubheader from "../components/AccountSubheader";
import AccountBackButton from "../components/AccountBackButton";

class AccountHomeViewAppliances extends Component {
  constructor(props) {
    super(props);
    const user = JSON.parse(localStorage.getItem("user"));
    const level = props.match.params.level;
    if (level == "infocare") {
      user.user_id = user.dependant_user_id;
    }
    this.props.dispatch(accountHomeViewActions.getAppliances(user));
  }
  render() {
    const {
      accountHomeView: { fetchingDetail, detail },
    } = this.props;

    const groupBy = (items, key) =>
      items.reduce(
        (result, item) => ({
          ...result,
          [item[key]]: [...(result[item[key]] || []), item],
        }),
        {}
      );

    let groupedAppliances = [];
    if (!fetchingDetail && detail.appliances !== undefined) {
      groupedAppliances = groupBy(detail.appliances, "show_appliance");
    }

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>

        <main className={css(styles.mainContainer)}>
          <AccountSubheader
            backHref={`/account/${this.props.match.params.level}/`}
            backLabel={this.props.match.params.level}
            title="Appliances"
          />
          <h2 className={css(styles.headerTitle)}>Edit Appliances</h2>
          <p className={css(styles.paragraphSmall)}>
            You can change the label and icon, and the visibility of each
            appliance.
          </p>
          <Spacer />
          {fetchingDetail && <Loading />}

          {!fetchingDetail && (
            <h3 className={css(styles.headerTitleSmall)}>Showing</h3>
          )}
          <Spacer />
          {!fetchingDetail &&
            groupedAppliances.true !== undefined &&
            groupedAppliances.true.map((appliance, i) => {
              return (
                <ApplianceListDisc
                  path={appliance.appliance_label.toLowerCase()}
                  order={1}
                  title={appliance.appliance_label}
                  // state={"on"}
                  key={i}
                  size={"small"}
                  id={appliance.appliance_type_id}
                  icon={`${appliance.appliance_icon}`}
                  isAssistedLiving={
                    this.props.match.params.level === "infocare" ? true : false
                  }
                  isSettings={true}
                />
              );
            })}

          {!fetchingDetail && (
            <h3 className={css(styles.headerTitleSmall)}>Hidden</h3>
          )}
          <Spacer />
          {!fetchingDetail &&
            groupedAppliances.false !== undefined &&
            groupedAppliances.false.map((appliance, i) => {
              return (
                <ApplianceListDisc
                  path={appliance.appliance_label.toLowerCase()}
                  order={1}
                  title={appliance.appliance_label}
                  key={i}
                  size={"small"}
                  id={appliance.appliance_type_id}
                  icon={`${appliance.appliance_icon}`}
                  isAssistedLiving={
                    this.props.match.params.level === "infocare" ? true : false
                  }
                  isSettings={true}
                />
              );
            })}
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let initialValues = {};

  return {
    initialValues,
    ...state,
  };
};

export default connect(mapStateToProps)(withCookies(AccountHomeViewAppliances));
